const setItemToLocalStorage = (key, value) =>
    localStorage.setItem(key, JSON.stringify(value));

const getItemFromLocalStorage = (key) => {
    const value = localStorage.getItem(key);
    if (value) {
        return JSON.parse(value);
    } else {
        return null;
    }
};

const clearLocalStorage = () => localStorage.clear();

export { clearLocalStorage, getItemFromLocalStorage, setItemToLocalStorage };
